import type { DeviceInfo, SensorReading } from '@grosync/common';
import { apiRequest } from './client';

export type DeviceDetail = DeviceInfo & { recentReadings: SensorReading[] };

export const fetchDevices = (): Promise<DeviceInfo[]> =>
  apiRequest<DeviceInfo[]>('/api/devices');

export const fetchDevice = (id: string): Promise<DeviceDetail> =>
  apiRequest<DeviceDetail>(`/api/devices/${id}`);

export const createDevice = (
  body: Record<string, unknown>,
): Promise<DeviceInfo> =>
  apiRequest<DeviceInfo>('/api/devices', {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const updateDevice = (
  id: string,
  body: Record<string, unknown>,
): Promise<DeviceInfo> =>
  apiRequest<DeviceInfo>(`/api/devices/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

export const deleteDevice = (id: string): Promise<void> =>
  apiRequest<void>(`/api/devices/${id}`, { method: 'DELETE' });
